// extracted by mini-css-extract-plugin
module.exports = {"container":"Home-module--container--etEXp","content":"Home-module--content--3n4Z9"};